import { createQueryKeys } from '@lukemorales/query-key-factory'

export const enterprise = createQueryKeys('enterprise', {
  detail: (enterpriseId: number) => [enterpriseId],
  memberUserIds: (enterpriseId: number) => [enterpriseId],
  membersSearch: (
    enterpriseId: number,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc',
    limit?: number,
    offset?: number,
    search?: string,
  ) => [enterpriseId, sortBy, sortOrder, limit, offset, search],
  membershipsAndInvitations: (
    enterpriseId: number,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc',
    limit?: number,
    offset?: number,
    query?: string,
    roles?: string[],
  ) => [enterpriseId, sortBy, sortOrder, limit, offset, query, roles],
  invitationsSent: (statusFilter?: string) => [statusFilter],
  apiKeys: (enterpriseId: number) => [enterpriseId],
  distributionSystems: (enterpriseId: number) => [enterpriseId],
  enterpriseLogs: (enterpriseId: number, limit?: number, offset?: number) => [enterpriseId, limit, offset],
  dashboardTransactionTypes: (enterpriseId: number) => [enterpriseId],
  dashboardAnalytics: (
    enterpriseId: number,
    transactionType: 'buy' | 'purchase' | 'refinance' | 'sell',
    memberUserIds?: number[],
  ) => [enterpriseId, transactionType, memberUserIds],
  dashboardAnalyticsBusinessRows: (
    enterpriseId: number,
    transactionType: 'buy' | 'purchase' | 'refinance' | 'sell',
    workflowKey: string,
    memberUserIds?: number[],
    sortBy?: 'client_name' | 'progress_percentage' | 'grade' | 'start_time',
    sortDirection?: 'asc' | 'desc',
    limit?: number,
  ) => [enterpriseId, transactionType, workflowKey, memberUserIds, sortBy, sortDirection, limit],
  dashboardAnalyticsUncategorized: (
    enterpriseId: number,
    memberUserIds?: number[],
    sortBy?: 'not_in_workflow_count' | 'in_first_conversation_count' | 'total',
    sortDirection?: 'asc' | 'desc',
    limit?: number,
  ) => [enterpriseId, memberUserIds, sortBy, sortDirection, limit],
  dashboardAnalyticsReferrals: (enterpriseId: number, memberUserIds?: number[], limit?: number) => [
    enterpriseId,
    memberUserIds,
    limit,
  ],
})
